import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-poshvine-skeleton-loader',
  styleUrls: ['./skeleton-loader.component.scss'],
  templateUrl: './skeleton-loader.component.html'
})
export class SkeletonLoaderComponent {
  @Input() size: 'medium' | 'small' = 'medium';
  @Input() flavor: 'rounded' | 'edged' = 'rounded';
  @Input() component: 'offer-detail' | 'card-primary' | 'offer-detail-mobile'
    | 'plain-square' | 'category-scroller' | 'plain-circle' | 'redemption-history' = 'card-primary';
  constructor() {

  }

}
